import { apiSlice } from '../../app/api/apiSlice';
import { AvailableChapels, CreateChapelRequest, CreateChapelResponse } from '../../types/chapel';
import { Chapel } from '../../types/package';
import { GetAvailableChapelResponse } from '../../types/response';

export const chapelApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAvailableChapel: builder.query<Chapel[], void>({
            query: () => '/api/chapel',
            transformResponse: (response: GetAvailableChapelResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: ['Chapel'],
        }),
        createNewChapel: builder.mutation<CreateChapelResponse, CreateChapelRequest>({
           query: (chapelForm) => ({
                url: '/api/chapel', 
                method: 'POST',
                body: chapelForm, 
           }),
           invalidatesTags: ['Chapel'],
        }),
        updateChapel: builder.mutation<CreateChapelResponse, { chapelId: number; data: CreateChapelRequest }>({
            query: ({ chapelId, data }) => ({
                url: `/api/chapel/${chapelId}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Chapel'], 
        }),
        getAvailableChapelsByDateAndTime: builder.query<AvailableChapels[], { startDate: string, startTime: string }>({
            query: ({ startDate, startTime }) => ({
                // url: `/api/chapel/available`,
                url: `/api/chapel/available?startDate=${startDate}&startTime=${startTime}`,
                method: "GET",
                params: { startDate, startTime },
            }),
        }),
    }),
});

export const { 
    useGetAvailableChapelQuery,
    useCreateNewChapelMutation,
    useUpdateChapelMutation,
    useGetAvailableChapelsByDateAndTimeQuery,
} = chapelApiSlice;